import { useTranslations } from '@npco/utils-translations'
import {
  ComingSoonBadge,
  useIsMobileResolution,
} from '@npco/zeller-design-system'

import { translationsShared } from 'translations/index'

import * as styled from './InvoiceIllustrationWithPill.styled'

interface IllustrationWithPillProps {
  illustration: JSX.Element
}

export const IllustrationWithPill = ({
  illustration,
}: IllustrationWithPillProps) => {
  const tShared = useTranslations(translationsShared)
  const isMobile = useIsMobileResolution()
  const isSmallMobile = useIsMobileResolution(387)

  return (
    <styled.Wrapper>
      <styled.BadgeWrapper isMobile={isMobile} isSmallMobile={isSmallMobile}>
        <ComingSoonBadge text={tShared('comingSoon')} />
      </styled.BadgeWrapper>

      {illustration}
    </styled.Wrapper>
  )
}
